import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';

import { Section } from '@website-builder/model/structure/section/section';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';
import { BuilderRootStructureType } from '@website-builder/model/state/builder-root-structure.type';

export class Page {
  readonly type: BuilderRootStructureType = BuilderElementType.Page;
  id = makeEntityId(EntityIdPrefix.PAGE);
  title = '';
  link = '';
  headerId: number;
  footerId: number;
  sections: Section[];
  previewUrl: string;
  languageCode: string;
  disabled: boolean;
  pageType?: string;
  pageCategory?: string;
  generatedPage?: {
    type: string;
    supplierId: string;
  } | null;

  static normalizeInPlace(page: Partial<Page>): Page {
    const purePage = new Page();

    page.id = page.id ?? purePage.id;
    page.title = page.title ?? purePage.title;
    page.link = page.link ?? purePage.link;
    page.headerId = page.headerId ?? purePage.headerId;
    page.footerId = page.footerId ?? purePage.footerId;
    page.sections = (page.sections ?? []).map(section => Section.normalizeInPlace(section));
    page.previewUrl = page.previewUrl ?? purePage.previewUrl;
    page.languageCode = page.languageCode ?? purePage.languageCode;
    page.disabled = page.disabled ?? purePage.disabled;
    page.pageType = page.pageType ?? purePage.pageType;
    page.pageCategory = page.pageCategory ?? purePage.pageCategory;
    page.generatedPage = page.generatedPage ?? purePage.generatedPage;

    return page as Page;
  }
}
